document.addEventListener('DOMContentLoaded', function () {
	const currentPath = window.location.pathname;
	const is404 = document.body.classList.contains('error404');

	const iconToggle = document.querySelector('.icon-toggle');
	const hideAnmeldeformular =
		currentPath === '/anmeldeformular-herunterladen/';

	if (iconToggle && (is404 || hideAnmeldeformular)) {
		iconToggle.style.display = 'none';
	}

	const miKostenloses = document.querySelector('.mi-kostenloses');
	const isKontaktPage =
		currentPath === '/kontakt/' || currentPath === '/kontakt';

	if (miKostenloses && isKontaktPage) {
		miKostenloses.style.display = 'none';
	}
});
